import {messages} from '@smartmixin/i18n';
import {MessageDescriptor} from 'react-intl';
import {CalendarAggregation} from './types';

export const metricToMessage: Record<string, MessageDescriptor> = {
  T: messages.units.temperature,
  U: messages.units.humidity,
  FF: messages.units.wind,
  SLP: messages.units.pressure,
  RR_1H: messages.units.precipitation,
  RR_RATE: messages.units.rainRate,
  RR_TODAY: messages.units.dailyPrecipitation,
  RR_3H: messages.units.precipitation,
  RR_6H: messages.units.precipitation,
  RR_12H: messages.units.precipitation,
  RR_24H: messages.units.precipitation,
  SOLAR_RADIATION: messages.units.solarRadiation,
  UV: messages.units.uv,
  VIS: messages.units.visibility,
  AQI: messages.units.AQI,
  PM_1: messages.units.PM_1,
  PM_10: messages.units.PM_10,
  PM_2P5: messages.units.PM_2P5,
  LIGHTNING_STRIKE_COUNT: messages.units.lightningStrikeCount,
};

/**
 * Metric-specific aggregated titles ("Maximum temperature", …) reusing the
 * long-standing report strings; other aggregatable metrics fall back to
 * genericAggregationMessages with the metric name as a placeholder.
 */
export const metricAggregationMessages: Record<
  string,
  Record<CalendarAggregation, MessageDescriptor>
> = {
  T: {
    avg: messages.reports.avgTemperature,
    min: messages.reports.minTemperature,
    max: messages.reports.maxTemperature,
  },
  U: {
    avg: messages.reports.avgHumidity,
    min: messages.reports.minHumidity,
    max: messages.reports.maxHumidity,
  },
  SLP: {
    avg: messages.reports.avgPressure,
    min: messages.reports.minPressure,
    max: messages.reports.maxPressure,
  },
};

export const genericAggregationMessages: Record<
  CalendarAggregation,
  MessageDescriptor
> = {
  avg: messages.reports.avgMetric,
  min: messages.reports.minMetric,
  max: messages.reports.maxMetric,
};
